import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import PageLayout from "../components/PageLayout";
import { supabase } from "../utils/supabaseClient";

export default function RootLayout({ session }) {
  return (
    <PageLayout>
      <Header session={session} onSignOut={() => supabase.auth.signOut()} />
      <div style={{ marginTop: 16 }}>
        <Outlet />
      </div>
    </PageLayout>
  );
}
